import React from 'react'
import EnrolledCourses from '../components/courses/EnrolledCourses';
import Navbar from "../components/Navbar/Navbar";




const EnrolledCoursesPage = () => {
    return ( 
        <>
       <Navbar/>
       <EnrolledCourses/>
        </>
     );
}
 
export default EnrolledCoursesPage;